import React from 'react';
// import {Alert} from "antd"
import 'antd/dist/antd.css';
import { Button, Alert } from 'antd';
// import {store} from "../redux/store"
import { useSelector } from "react-redux"
import { useState } from 'react';
function Timer() {

  const [score, setScore] = useState("")
   const stateeee=useSelector(state=>state.ourState.score)
  const watchScore = () => {
    // setScore("5")

    // console.log("state",score)
    setScore(stateeee)
  }
  return(
      <> <div style={{display:"flex",
      flexDirection:"column",
      justifyContent:'center',alignItems:"center",
      height:"40vh"}}>
                <Alert message="Sorry 😔, time is  finished." type="info" showIcon />
            <div style={{marginTop:"20px"}}>
            <Button onClick={watchScore} type="primary" htmlType="submit">
          Click to see score
        </Button>
            </div>
            <div >
          <p style={{ textAlign:"center",padding:"20px",color:"white", height: "70px", marginTop: "20px", width: "70px", borderRadius: "50%", backgroundColor: "#1890ff" }}>{score}</p>
        </div>

      </div>
      
     
      </>)
      ;
}



export default Timer;
